module.exports = __webpack_public_path__ + "static/img/core5.586be08a.png";